import React, { useState } from 'react'
import './Filter.css'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
  setPatientStatusActive,
  fetchPatientsAsync,
  setPatientData,
} from '../patientsSlice'
import { Button } from '@mui/material'
import { exportExcel } from '../../../utils/hooks/Utils'
import { formmattedPatientList } from '../utils'
import { toast } from 'react-toastify'
import KeycloakService from '../../../utils/keycloakService'
import { ADMIN_EXPORT_DATA } from '../../../utils/roles'
import { roleErrorMessage } from '../constants'

const FilterButton = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  // const [statusFilter, setStatusFilter] = useState<'active' | 'inactive'>(
  //   'active'
  // )
  const [isActionOpen, setIsActionOpen] = useState(false)

  const dispatch = useAppDispatch()
  const patients = useAppSelector((state) => state.patients?.data)

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen)
    setIsActionOpen(false)
  }

  const handleStatusFilterChange = (filter: 'active' | 'inactive') => {
    // setStatusFilter(filter)
    dispatch(setPatientStatusActive(filter === 'active'))
    dispatch(fetchPatientsAsync())
  }

  const handleDownload = () => {
    const patientList = formmattedPatientList(patients)
    if (patientList?.length === 0) {
      toast?.error('No Data.Refresh page')
    } else {
      exportExcel(patientList)
    }
    setIsActionOpen(false)
  }

  const toggleAction = () => {
    setIsActionOpen(!isActionOpen)
    setIsFilterOpen(false)
    if (!KeycloakService?.hasRole([ADMIN_EXPORT_DATA])) {
      toast.error(roleErrorMessage)
    }
  }
  const handleFilterData = () => {
    if (!patients) return
    const filteredPatients = patients.filter((patient) => {
      const identifier = patient?.resource?.identifier?.[2]?.value
      return (
        identifier?.startsWith('MUH888') || identifier?.startsWith('MUH777')
      )
    })
    dispatch(setPatientData(filteredPatients))
  }

  return (
    <div className='filter-dropdown'>
      <Button
        sx={{
          textTransform: 'none',
        }}
        className='filter-button'
        onClick={toggleFilter}
        disableRipple
      >
        Filter
      </Button>
      <Button
        sx={{
          textTransform: 'none',
        }}
        className='filter-button'
        onClick={toggleAction}
      >
        Action
      </Button>
      {isFilterOpen && (
        <div className='dropdown-content'>
          <div
            className='menu2'
            onClick={() => handleStatusFilterChange('active')}
          >
            Active
          </div>
          <div
            className='menu2'
            onClick={() => handleStatusFilterChange('inactive')}
          >
            Inactive
          </div>
          <div className='menu2' onClick={handleFilterData}>
            Other Registrations
          </div>
        </div>
      )}
      {isActionOpen && KeycloakService?.hasRole([ADMIN_EXPORT_DATA]) && (
        <div className='dropdown-content' style={{ marginLeft: '4rem' }}>
          <div
            className='menu3'
            onClick={handleDownload}
            aria-disabled={patients?.length === 0}
          >
            Export
          </div>
        </div>
      )}
    </div>
  )
}

export default FilterButton
